<template>
    <div class="wrapper">
        <div class="tit">
            <h1>{{ editing ? 'Editar' : 'Nueva' }} entrada</h1>
        </div>
        <div class="ctn_general">

            <div class="tabla_ctn subir_producto">
                <div class="tabla_filtros">
                    <div class="tfiltros_col">
                        <p>Datos de la entrada</p>
                    </div>
                </div>
                <div class="datos_producto_ctn">
                    <form class="formulario_x2" @submit.prevent="onProcess">
                        <c-input type="text" :field="$v.title" id="title" classes="grupo_campos tipo_text"
                                 label="Título *" length="150"/>
                        <c-input type="text" :field="$v.localSlug" id="slug" classes="grupo_campos tipo_text"
                                 label="Slug *" length="300"/>
                        <div class="grupo_campos tipo_checkbox" v-if="editing">
                            <div class="checkbox_field" style="padding-bottom: 0px">
                                <input type="checkbox" id="updateSlugCbk" v-model="updateSlug">
                                <label for="updateSlugCbk">Actualizar slug</label>
                            </div>
                        </div>
                        <c-input type="text" :field="$v.seoTitle" id="title" classes="grupo_campos tipo_text"
                                 label="Título SEO *" length="150"/>
                        <c-input type="text" :field="$v.metaDescription" id="title" classes="grupo_campos tipo_text"
                                 label="Meta Descripción *" length="150"/>
                        <c-input type="text" :field="$v.keyword" id="title" classes="grupo_campos tipo_text"
                                 label="Palabra Clave *" length="150"/>
                        <div class="grupo_campos typeFile">
                            <label>Imagen de portada</label>
                            <div id="pictureDz">
                                <div class="dz-default dz-message" data-dz-message="">
                                    <span class="imgCtn" v-if="!image && !uploading">
                                        <i class="fa fa-camera fa-2x"></i>
                                        <p>Añadir archivo</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <c-input type="text" :field="$v.tags" id="tags"
                                 classes="grupo_campos tipo_text" label="Etiquetas (separar por comas)"/>
                        <div class="grupo_campos">
                            <label>Contenido</label>
                            <editor
                                :api-key="tinymceApiKey"
                                v-model="content"
                                id="description"
                                ref="testeditor"
                                :init="{
                                     height: 500,
                                     menubar: false,
                                     language : 'es',
                                     paste_as_text: true,
                                     forced_root_block : '',
                                     images_upload_handler: imageHandler,
                                     plugins: [
                                       'advlist autolink lists link image charmap print preview anchor paste',
                                       'searchreplace visualblocks code fullscreen',
                                       'insertdatetime media table paste image imagetools code help wordcount'
                                     ],
                                     toolbar:
                                       'undo redo | formatselect | bold italic backcolor | \
                                       alignleft aligncenter alignright alignjustify | \
                                       bullist numlist outdent indent imageupload | removeformat | code help image',
                                    }"
                            />
                        </div>
                        <div class="grupo_boton">
                            <router-link tag="button" class="btn btn2" :to="{name:'articles'}">{{
                                    editing ? 'Volver' :
                                        'Cancelar'
                                }}
                            </router-link>
                            <button class="btn" type="submit">{{ editing ? 'Actualizar' : 'Publicar' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import CInput from '../common/CInput.vue'
import alert from '../../util/alert'
import {required} from 'vuelidate/lib/validators'
import ArticleService from "../../services/ArticleService";
import AssetService from "../../services/AssetService";
import {toSlug} from '../../util/util';
import Editor from '@tinymce/tinymce-vue'
import firebase from 'firebase/app';
import {AUTH_TOKEN} from "../../util/constants";

export default {
    props: {
        slug: {
            type: String,
            required: false,
        }
    },
    components: {CInput, Editor},
    data() {
        return {
            editing: false,
            id: null,
            title: null,
            seoTitle: null,
            metaDescription: null,
            keyword: null,
            image: null,
            tags: null,
            content: null,
            updateSlug: false,
            tinymceApiKey: process.env.TINYMCE_API_KEY,
            uploading: false,
        }
    },
    validations: {
        title: {required},
        seoTitle: {required},
        metaDescription: {required},
        keyword: {required},
        localSlug: {required},
        content: {},
        tags: {},
    },
    computed: {
        localSlug() {
            const self = this;
            if (self.updateSlug || !self.editing) {
                let slug = '';
                slug += toSlug(self.title);
                return slug;
            } else
                return self.slug;
        },
    },
    watch: {
        slug: function () {
            if (this.slug)
                this.load(this.slug);
            else {
                this.clear();
            }
        }
    },
    methods: {
        async load(slug) {
            const self = this;
            try {
                const response = (await ArticleService.get({slug})).data.payload;
                const {article} = response;
                self.id = article._id;
                self.title = article.title;
                self.seoTitle = article.seoTitle;
                self.metaDescription = article.metaDescription;
                self.keyword = article.keyword;
                self.image = article.image;
                self.content = article.content;
                self.tags = article.tags.join(',');
                self.editing = true;
                self.initDropzone();
            } catch (error) {
                if (error.response && error.response.data)
                    alert.error(error.response.data.message);
                else
                    alert.error("No se encontró entrada");
            }
        },
        clear() {
            this.editing = false;
            this.title = null;
            this.seoTitle = null;
            this.metaDescription = '';
            this.keyword = null;
            this.image = null;
            this.content = null;
            this.tags = null;
            this.$v.$reset();
            this.dropzone.removeAllFiles(true);
        },
        async onProcess() {
            const self = this;
            self.$v.$touch();
            if (self.$v.$error) {
                self.scrollToError();
                return;
            }

            const data = {
                title: self.title,
                slug: self.localSlug,
                seoTitle: self.seoTitle,
                metaDescription: self.metaDescription,
                keyword: self.keyword,
                image: self.image,
                tags: self.tags.split(','),
                content: self.content,
                updateSlug: self.updateSlug
            };

            try {
                let resp;
                if (self.editing)
                    resp = (await ArticleService.update(self.id, data)).data.payload;
                else
                    resp = (await ArticleService.save(data)).data.payload;

                alert.success("Se guardó información de la entrada correctamente");
                self.$router.push({name: 'article-editor', params: {slug: resp.slug}});
                self.editing = true;
            } catch (error) {
                if (error)
                    alert.error(error);
                else
                    alert.error("Error al guardar la entrada");
            }
        },
        scrollToError() {
            setTimeout(() => {
                const el = $('.error:visible:first');
                if (el) {
                    $('html, body').animate({
                        scrollTop: el.offset().top - 50
                    }, 500);
                }
            }, 100);
        },
        removeAsset() {
            document.getElementById("assetInput").value = "";
            this.asset = null;

        },
        initDropzone() {
            const self = this;
            setTimeout(async () => {
                self.dropzone = new Dropzone("div#pictureDz",
                    {
                        paramName: "asset",
                        maxFilesize: 8, // MB
                        maxFiles: 1, // MB
                        acceptedFiles: ".png, .jpeg, .jpg, .webp, .gif, .mp4, .avi",
                        addRemoveLinks: true,
                        previewTemplate: "<div class=\"dz-default dz-message pubSubirImgItem pubItemCargado dz-preview dz-file-preview\"><span class=\"imgCtn\"><img data-dz-thumbnail/></span></div>",
                        url: `${process.env.SVC_URL}/a/asset`,
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
                            'Cache-Control': null,
                            'X-Requested-With': null,
                        },
                        dictCancelUploadConfirmation: "¿Está seguro que desea cancelar la carga?",
                        dictCancelUpload: "Cancelar carga",
                        dictRemoveFile: "Remover",

                    });

                self.dropzone.on("maxfilesexceeded", function (file) {
                    self.dropzone.removeAllFiles();
                    self.dropzone.addFile(file);
                });

                /*self.dropzone.on("addedfile", function (file, done) {
                    const $previewEl = $("video#preview");
                    if ($previewEl[0].canPlayType(file.type) !== "no") {
                        const fileURL = URL.createObjectURL(file);
                        $($previewEl).one('loadeddata', function () {
                            URL.revokeObjectURL(fileURL);
                        });
                        $previewEl[0].src = fileURL;
                    }
                });
*/
                self.dropzone.on("removedfile", function (file) {
                    self.image = null;
                });

                self.dropzone.on("maxfilesizeexceeded", function (file) {
                    self.dropzone.removeFile(file);
                    alert.error("Error, el archivo de imagen no debe exceder los 8MB");
                });

                self.dropzone.on("success", function (file, response) {
                    self.uploading = false;
                    self.image = response.payload.url;
                });

                self.dropzone.on("error", function (file, data) {
                    if (data === 'You can not upload any more files.') {
                        self.dropzone.removeFile(file);
                    } else {
                        self.uploading = false;
                        alert.error('Ocurrió un error al cargar imagen.');
                    }
                    self.image = null;
                });

                self.dropzone.on("sending", function (file, xhr, formData) {
                    self.uploading = true;
                });

                if (self.image) {
                    let mockFile = {
                        name: "logo",
                        dataURL: self.image,
                        accepted: true
                    };
                    self.dropzone.files.push(mockFile);
                    self.dropzone.emit("addedfile", mockFile);
                    self.dropzone.createThumbnailFromUrl(mockFile,
                        self.dropzone.options.thumbnailWidth,
                        self.dropzone.options.thumbnailHeight,
                        self.dropzone.options.thumbnailMethod, true, function (thumbnail) {
                            self.dropzone.emit('thumbnail', mockFile, thumbnail);
                        }, "Anonymous");
                    self.dropzone.emit('complete', mockFile);
                }
            }, 500);
        },
        async imageHandler(blobInfo, success, failure){
            const formData = new FormData();
            formData.append('asset', blobInfo.blob(), blobInfo.filename());
            const resp = await AssetService.upload(formData);
            success(resp.data.payload.url);
        }
    },
    async mounted() {
        const self = this;
        if (self.slug)
            self.load(self.slug);
        else
            self.initDropzone();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/articles/Article.vue